
const modal = document.querySelector('.mr-modal'); 

document.addEventListener("DOMContentLoaded", () => {
  const successFlag = document.getElementById("newsletterSuccessFlag");
  const modal = document.getElementById("signupModal");
  const closeBtn = document.getElementById("closeModal");

  if (successFlag?.dataset.newsletterSuccess === "1" && modal) {
    modal.hidden = false;
    document.body.classList.add("no-scroll");
  }

  closeBtn?.addEventListener("click", () => {
    modal.hidden = true;
    document.body.classList.remove("no-scroll");

    // Optional: clean URL hash/query so refresh doesn't re-open modal
    if (window.history?.replaceState) {
      const cleanUrl = window.location.pathname + window.location.search.replace(/(\?|&)(customer_posted|contact_posted|form_type|utf8)=[^&]*/g, "").replace(/[?&]$/, "") + window.location.hash;
      window.history.replaceState({}, "", cleanUrl);
    }
  });
});

const params = new URLSearchParams(window.location.search);
const urlSaysSuccess =
  params.get("customer_posted") === "true" ||
  params.get("contact_posted") === "true";

if (urlSaysSuccess && modal) {
  modal.hidden = false;
  document.body.classList.add("no-scroll");
}